import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { selectIsSmallScreen } from 'store/pageStore/selectors';
import { PriceTextSmall } from '../price-text';

type CatalogueOrderButtonProps = {
	priceText: string;
	unitOfMeasurement: string;
};

export const CatalogueOrderButton = ({
	priceText,
	unitOfMeasurement,
}: CatalogueOrderButtonProps) => {
	const isSmallScreen = useSelector(selectIsSmallScreen);

	return isSmallScreen ? (
		<PriceTextSmall
			unitOfMeasurement={unitOfMeasurement}
			priceText={priceText}
			data-qa="catalogue-order-btn-content--small"
		/>
	) : (
		<Typography variant="s" size="body_long" data-qa="catalogue-order-btn-content">
			Заказать
		</Typography>
	);
};
